import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import {SessionManagerService} from "../services/session-manager.service";

@Injectable({
  providedIn: 'root'
})
export class PatientRouteGuard implements CanActivate {
  constructor(private sessionManager: SessionManagerService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.sessionManager.getPatientData();
    if (this.sessionManager.loggedInAsPatient) {
      return true;
    } else {
      this.router.navigate(['/pacientes/cadastro']);
      return false;
    }
  }

}
